import React from 'react';
import { enumHelper } from '../../utils';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums/index';
import DeleteDaysModal from '../../screens/reserves/timingTable/List/DeleteDaysModal';
import { NavLink } from 'react-router-dom';

const renderStatusColors = scheduleStatus => {
  switch (scheduleStatus) {
    case 'OPEN':
      return 'text-success';
    case 'CLOSE':
      return 'text-danger';
    case 'SUSPENDED':
      return 'text-warning';
    default:
      return 'text-info';
  }
};
export const reservationTimingColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام کافه',
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_DATES_LIST_FOR_ADMIN,
    dataIndex: 'cafeName',
    name: 'cafeName',
    isSortable: true,
  },
  {
    title: 'تاریخ شروع',
    dataIndex: 'fromDate',
    // change name from "fromDate" to "date" for sort table.
    name: 'date',
    isSortable: true,
  },
  {
    title: 'تاریخ پایان',
    dataIndex: 'toDate',
    name: 'toDate',
    isSortable: false,
  },
  {
    title: 'روزهای هفته',
    dataIndex: 'weekDays',
    name: 'weekDays',
    isSortable: false,
    render: weekDays => (
      <div className={`direction-ltr`}>
        {ENUMS.SCHEDULE_WEEK_DAYS.list
          .filter(x => weekDays.some(ele => ele === x.value))
          .map((ele, index, self) => ` ${locales(ele.title)} ${index < self.length - 1 ? '،' : ''}`)}
      </div>
    ),
  },
  {
    title: 'وعده‌های غذایی روز',
    dataIndex: 'mealsInfo',
    name: 'mealsInfo',
    isSortable: false,
    render: mealsInfo => (
      <div className={`direction-ltr`}>
        {mealsInfo && mealsInfo.length
          ? ENUMS.MEAL_PORTIONS.list
            .filter(x => mealsInfo.some(ele => ele === x.value))
            .map((ele, index, self) => ` ${ele.title} ${index < self.length - 1 ? '،' : ''}`)
          : ' '
        }
      </div>
    ),
  },
  {
    title: 'نوع رزرو',
    dataIndex: 'reserveTypes',
    name: 'reserveTypes',
    isSortable: false,
    render: reserveTypes => (
      <div className={`direction-ltr`}>
        {ENUMS.RESERVATION_TYPES.list
          .filter(x => reserveTypes.some(ele => ele == x.value))
          .map((ele, index, self) => ` ${ele.title} ${index < self.length - 1 ? '،' : ''}`)}
      </div>
    ),
  },
  {
    title: 'وضعیت',
    dataIndex: 'scheduleStatus',
    name: 'scheduleStatus',
    isSortable: false,
    render: scheduleStatus => (
      <div className={renderStatusColors(scheduleStatus)}>
        {enumHelper.convertEnumValueToTitle(ENUMS.RESERVATION_STATUS.list, scheduleStatus)}
      </div>
    ),
  },
  {
    title: 'ایجاد کننده',
    dataIndex: 'createdFullName',
    name: 'createdFullName',
    isSortable: true,
  },
  {
    title: 'عملیات',
    dataIndex: '',
    name: '',
    isSortable: false,
    action: item => (
      <div className='d-flex'>
        <DeleteDaysModal record={item} />
        <NavLink
          to={{
            pathname: '/reservation-timing/edit-timing',
            editMode: true,
            item: item,
            permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_SCHEDULE_DETAILS,
          }}
          title={locales('title.edit.timing')}
        >
          <i className="text-center fa fa-pencil text-secondary pointer" />
        </NavLink>
      </div>
    ),
  },
];